import { render, staticRenderFns } from "./LawLedesTypeList.vue?vue&type=template&id=405efd5d&"
import script from "./LawLedesTypeList.vue?vue&type=script&lang=js&"
export * from "./LawLedesTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesTypeList.vue?vue&type=style&index=0&id=405efd5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports